import styled from "styled-components";
import {Card} from "antd";

export const StyledCallCard = styled(Card)`
  border: 1px solid #f0f0f0;
  /* box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.05); */
  border-radius: 5px;

  .call-card-description {
    font-weight: 400;
    font-size: 1.4rem;
    color: #1c1726;
    overflow: hidden;
    display: -webkit-box;
    /* display 1 lines only */
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;
  }
`;

export const StyledCallCardExtraInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 1.6rem;
  flex-wrap: wrap;

  .phone-number-extra-details {
    display: flex;
    align-items: center;
    gap: 1.6rem;
  }

  .call-card-extra-info-item {
    .call-card-extra-info-item-value {
      // font-family: Red Hat Display !important;
      font-weight: 500;
      font-size: 1.4rem;
      color: #1c1726;
    }
  }
`;
export const StyledModalContentWrapper = styled.div`
  padding: 1.6rem 2.4rem;
  /* background-color: #f5f5f5; */
  background-color: #fff;
  border-radius: 5px;
  .footer-buttons {
    display: flex;
    justify-content: space-between;
    margin-top: 4rem;
  }
  .footer-buttons button {
    width: 49%;
  }
  @media (max-width: 500px) {
    .footer-buttons {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-top: 4rem;
      gap: 1rem;
    }
    .footer-buttons button {
      width: 100%;
    }
  }
  .footer-button {
    display: flex;
    justify-content: center;
    margin-top: 4rem;
  }
  .footer-button button {
    width: 100%;
  }
  .ant-modal-footer {
    padding: 0;
  }
`;
export const StyledModalContentInfo = styled.div`
  font-size: 1.4rem;
  .content-heading {
    font-weight: 500;
  }
  .content-text {
    font-weight: 400;
    margin-top: 1rem;
  }
  .splash-screen-title {
    margin-bottom: 2rem;
    font-size: 24px;
  }
  @media (max-width: 500px) {
    .splash-screen-title {
      margin-bottom: 2rem;
      font-size: 25px;
    }
  }
  .splash-screen-title img {
    width: 15%;
  }
`;
export const StyledCardDetailsButtonWrapper = styled.div`
  display: flex;
  // align-items: center;
  gap: 1rem;

  @media (max-width: 500px) {
    margin-top: 1.3rem;
    flex-direction: column;
  }
`;
